/// <amd-module name="SuiteCommerce.LookBook.PDP.LookItem.CollectionView"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.LookBook.PDP.LookItem.CollectionView", ["require", "exports", "underscore", "suitecommerce_lookbook_pdp_lookitem_collection.tpl", "suitecommerce_lookbook_pdp_lookitem_row.tpl", "suitecommerce_lookbook_pdp_lookitem_cell.tpl", "SuiteCommerce.LookBook.Common.Configuration", "SuiteCommerce.LookBook.LookItem.CollectionView", "SuiteCommerce.LookBook.Common.Utils", "SuiteCommerce.LookBook.Instrumentation"], function (require, exports, _, pdpLookItemCollectionTpl, pdpLookItemRowTpl, pdpLookItemCellTpl, Configuration_1, LookItem_CollectionView_1, Utils_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.PDPLookItemCollectionView = void 0;
    var PDPLookItemCollectionView = /** @class */ (function (_super) {
        __extends(PDPLookItemCollectionView, _super);
        function PDPLookItemCollectionView(options) {
            var _this = _super.call(this, options) || this;
            _this.viewsPerRow = Infinity;
            _this.template = pdpLookItemCollectionTpl;
            _this.cellTemplate = pdpLookItemCellTpl;
            _this.rowTemplate = pdpLookItemRowTpl;
            _this.itemId = options.itemId;
            LookItem_CollectionView_1.LookItemCollectionView.prototype.initialize.call(_this, options);
            return _this;
        }
        PDPLookItemCollectionView.prototype.setupCarousel = function () {
            var carousel;
            var imgMinHeight;
            var thumbnailSize;
            if (this.collection.length) {
                carousel = this.$('[data-type="carousel-look-items"]');
                if (!Utils_1.Utils.isPhoneDevice() && Configuration_1.Configuration.siteSettingsImageSizes) {
                    thumbnailSize = _.where(Configuration_1.Configuration.siteSettingsImageSizes, {
                        name: Configuration_1.Configuration.imageSizeMappingThumbnail,
                    });
                    imgMinHeight = thumbnailSize && thumbnailSize[0].maxheight;
                    carousel.find('.look-item-link-image').css('minHeight', imgMinHeight);
                }
                this.$(carousel).bxSliderNew(Configuration_1.Configuration.bxSliderDefault);
            }
        };
        PDPLookItemCollectionView.prototype.logUsageOfLookInPDP = function () {
            if (this.collection.length > 0) {
                var logUsage = Instrumentation_1.default.getLog('Usage of look in PDP');
                logUsage.setParameters({
                    activity: 'Usage of look in PDP',
                    instanceCount: (this.collection.length) + 1
                });
                logUsage.submit();
            }
        };
        PDPLookItemCollectionView.prototype.getContext = function () {
            return {
                sectionTitle: Configuration_1.Configuration.pdpSectionTitle,
                name: this.itemId,
                showCells: !!this.collection.length,
            };
        };
        return PDPLookItemCollectionView;
    }(LookItem_CollectionView_1.LookItemCollectionView));
    exports.PDPLookItemCollectionView = PDPLookItemCollectionView;
});
